export default __webpack_public_path__ + "static/media/pdfIcon.22199da6.svg";